export const INIT_TWO_FACTOR_ENABLED = 'two_factor/INIT_TWO_FACTOR_ENABLED'
export const INITIATE_2FA_SETUP = 'two_factor/INITIATE_2FA_SETUP'
export const INITIATE_2FA_SETUP_REQUEST = `${INITIATE_2FA_SETUP}_REQUEST`
export const INITIATE_2FA_SETUP_SUCCESS = `${INITIATE_2FA_SETUP}_SUCCESS`
export const INITIATE_2FA_SETUP_FAILURE = `${INITIATE_2FA_SETUP}_FAILURE`

export const VERIFY_2FA_SETUP = 'two_factor/VERIFY_2FA_SETUP'
export const VERIFY_2FA_SETUP_REQUEST = `${VERIFY_2FA_SETUP}_REQUEST`
export const VERIFY_2FA_SETUP_SUCCESS = `${VERIFY_2FA_SETUP}_SUCCESS`
export const VERIFY_2FA_SETUP_FAILURE = `${VERIFY_2FA_SETUP}_FAILURE`

export const DISABLE_2FA = 'two_factor/DISABLE_2FA'
export const DISABLE_2FA_REQUEST = `${DISABLE_2FA}_REQUEST`
export const DISABLE_2FA_SUCCESS = `${DISABLE_2FA}_SUCCESS`
export const DISABLE_2FA_FAILURE = `${DISABLE_2FA}_FAILURE`


export const initTwoFactorEnabled = (isEnabled) => ({ type: INIT_TWO_FACTOR_ENABLED, isEnabled})

export const initiate2FASetup = () => {
  return {
    type: INITIATE_2FA_SETUP,
    request: {
      url: '/users/two_factor/initiate_setup',
      method: 'post',
    },
  }
}

export const verify2FASetup = (otpCode: string) => {
  return {
    type: VERIFY_2FA_SETUP,
    request: {
      url: '/users/two_factor/verify_setup',
      method: 'post',
      body: { otp_attempt: otpCode },
    },
  }
}

export const disable2FA = () => {
  return {
    type: DISABLE_2FA,
    request: {
      url: '/users/two_factor/disable',
      method: 'post',
    },
  }
}
